module.exports = __webpack_public_path__ + "06_mustache_grey.84e5eebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/06_mustache_grey.png
// module id = 2P2E
// module chunks = 0